export enum ButtonAlignment {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}
